<template>
  <b-card v-if="!!option" id="page-company-form" no-body class="mb-0">
    <b-card-header>
      <b-card-title>
        <h2>
          {{ $t(getTitle()) }} {{ $t("pages.companies.title2").toLowerCase() }}
          {{ companyFather.name }}
        </h2>
      </b-card-title>
      <b-button type="button" variant="primary" @click="goBack">
        <feather-icon icon="ArrowLeftIcon" />
        {{ $t("back") }}
      </b-button>
    </b-card-header>

    <b-card-body>
      <form-wizard
        ref="form"
        color="#44b8ff"
        :title="null"
        :subtitle="null"
        shape="square"
        class="mb-3 shadow-none"
      >
        <!-- Referencia al tipo de empresa -->
        <tab-content
          :title="$t('pages.companies.typeCompanies')"
          :before-change="validationTypeCompany"
          ref="formTypeCompany"
        >
          <validation-observer ref="typeCompanyRules" tag="form">
            <b-form>
              <b-row>
                <!-- Tipo de actividad -->
                <b-col cols="12" md="6">
                  <b-form-group
                    :label="$t(label('activityType'))"
                    label-for="idCatActivitySelected"
                  >
                    <validation-provider
                      #default="{ errors }"
                      :name="$t(label('activityType'))"
                      rules="required"
                    >
                      <b-form-radio-group
                        v-model="selected"
                        input-id="idCatActivitySelected"
                        :disabled="!isSaveMode"
                        class="vertical-spacing"
                        stacked
                      >
                        <b-form-radio :value="1">
                          {{ $t(label("products")) }}
                        </b-form-radio>
                        <b-form-radio :value="2">
                          {{ $t(label("services")) }}
                        </b-form-radio>
                        <b-form-radio :value="3">
                          {{ $t(label("productsServices")) }}
                        </b-form-radio>
                        <b-form-radio :value="4">
                          {{ $t(label("informative")) }}
                        </b-form-radio>
                        <b-form-radio :value="5">
                          {{ $t(label("servicesProfessional")) }}
                        </b-form-radio>
                        <b-form-radio :value="6">
                          {{ $t(label("reservations")) }}
                        </b-form-radio>
                      </b-form-radio-group>
                      <b-form-invalid-feedback
                        :state="errors.length > 0 ? false : null"
                      >
                        {{ errors[0] }}
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col cols="12" md="6" />

                <!-- Tipo de propiedad -->
                <b-col cols="12" md="6">
                  <validation-provider
                    #default="{ errors }"
                    :name="$t(label('type'))"
                    rules="required"
                  >
                    <b-form-group
                      :label="$t(label('type'))"
                      label-for="type"
                      :state="errors.length > 0 ? false : null"
                    >
                      <v-select
                        v-model="companyType.idCatCompanyOwnership"
                        input-id="type"
                        :options="listCatCompany"
                        label="name"
                        :placeholder="$t(label('type'))"
                        :disabled="!isSaveMode"
                        :reduce="(option) => option.id"
                      >
                        <span slot="no-options">{{ $t("sorryOption") }}</span>
                      </v-select>
                      <b-form-invalid-feedback
                        :state="errors.length > 0 ? false : null"
                      >
                        {{ errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </b-col>

                <!-- Tamaño de la empresa -->
                <b-col cols="12" md="6">
                  <validation-provider
                    #default="{ errors }"
                    :name="$t(label('companySize'))"
                    rules="required"
                  >
                    <b-form-group
                      :label="$t(label('companySize'))"
                      label-for="typesCatSizes"
                      :state="errors.length > 0 ? false : null"
                    >
                      <v-select
                        input-id="typesCatSizes"
                        v-model="companyType.idCatSize"
                        :options="listCatSizes"
                        label="name"
                        :placeholder="$t(label('companySize'))"
                        :disabled="!isSaveMode"
                        :reduce="(option) => option.id"
                      >
                        <span slot="no-options">{{ $t("sorryOption") }}</span>
                      </v-select>
                      <b-form-invalid-feedback
                        :state="errors.length > 0 ? false : null"
                      >
                        {{ errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </b-col>

                <!-- Área de operación -->
                <b-col cols="12" md="6">
                  <validation-provider
                    #default="{ errors }"
                    :name="$t(label('areaOperation'))"
                    rules="required"
                  >
                    <b-form-group
                      :label="$t(label('areaOperation'))"
                      label-for="typesCatGeographicAreaOfOperations"
                      :state="errors.length > 0 ? false : null"
                    >
                      <v-select
                        v-model="companyType.idCatGeographicAreaOfOperation"
                        input-id="typesCatGeographicAreaOfOperations"
                        :options="listCatGeographic"
                        label="name"
                        :placeholder="$t(label('areaOperation'))"
                        :disabled="!isSaveMode"
                        :reduce="(option) => option.id"
                      >
                        <span slot="no-options">{{ $t("sorryOption") }}</span>
                      </v-select>
                      <b-form-invalid-feedback
                        :state="errors.length > 0 ? false : null"
                      >
                        {{ errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </b-col>

                <!-- Tipo de moneda -->
                <b-col cols="12" md="6">
                  <validation-provider
                    #default="{ errors }"
                    :name="$t(label('coinTypes'))"
                    rules="required"
                  >
                    <b-form-group
                      :label="$t(label('coinTypes'))"
                      label-for="coinTypes"
                      :state="errors.length > 0 ? false : null"
                    >
                      <v-select
                        v-model="companyType.idCatCoinType"
                        input-id="coinTypes"
                        :options="listCoinTypes"
                        label="name"
                        :placeholder="$t(label('coinTypes'))"
                        :disabled="!isSaveMode"
                        :reduce="(option) => option.id"
                      >
                        <span slot="no-options">{{ $t("sorryOption") }}</span>
                      </v-select>
                      <b-form-invalid-feedback
                        :state="errors.length > 0 ? false : null"
                      >
                        {{ errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </b-col>

                <!-- Contexto de la empresa -->
                <b-col cols="12" md="6">
                  <b-form-group
                    :label="$t(label('companyContext'))"
                    label-for="companyContext"
                  >
                    <b-form-textarea
                      id="companyContext"
                      v-model="companyType.businessContext"
                      :placeholder="$t(label('companyContext'))"
                      :disabled="!isSaveMode"
                      rows="10"
                    />
                  </b-form-group>
                </b-col>

                <!-- Editor JSON -->
                <b-col cols="12" md="6">
                  <b-form-group
                    :label="$t(label('jsonEditor'))"
                    label-for="jsonFunction"
                  >
                    <vue-json-editor
                      id="jsonFunction"
                      class="json-editor"
                      v-model="companyType.jsonFunction"
                      :show-btns="false"
                      :expandedOnStart="true"
                      @json-change="onJsonChange"
                    >
                    </vue-json-editor>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form>
          </validation-observer>
        </tab-content>
        <!-- <b-col cols="12" md="6">
                <validation-provider
                  #default="{ errors }"
                  :name="$t(label('activityType'))"
                  rules="required"
                >
                  <b-form-group
                    :label="$t(label('activityType'))"
                    label-for="idCatActivitySelected"
                    :state="errors.length > 0 ? false : null"
                  >
                    <v-select
                      v-model="companyType.idCatActivity"
                      input-id="idCatActivitySelected"
                      multiple
                      :options="listCatActivitys"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="name"
                      :placeholder="$t(label('activityType'))"
                      :disabled="!isSaveMode"
                      :reduce="(option) => option.id"
                    >
                      <span
                        slot="no-options"
                        click="$refs.activityType.open = false"
                      >{{ $t('sorryOption') }}</span>
                    </v-select>
                    <b-form-invalid-feedback :state="errors.length > 0 ? false : null">
                      {{ errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>   
                </validation-provider>
              </b-col> -->
        <!-- Detalle de la empresa -->
        <tab-content
          :title="$t('pages.companies.detailCompanies')"
          :before-change="validationDetailCompany"
          ref="formDetailCompany"
        >
          <!-- Detalles de la empresa -->
          <validation-observer ref="detailCompanyRules" tag="form">
            <b-form>
              <b-row>
                <!-- Logo de la empresa -->
                <b-col
                  v-if="option != 2"
                  cols="12"
                  md="6"
                  class="d-flex align-items-center justify-content-center"
                >
                  <b-form-group
                    :label="$t(label('logo'))"
                    label-for="inputFilePhoto"
                  >
                    <b-media class="body-style">
                      <div v-if="!company.urlLogo && option != 2">
                        <input
                          id="inputFilePhoto"
                          ref="fileInputPhotoReference"
                          name="inputFilePhoto"
                          type="file"
                          class="hidden"
                          accept=".png,.peg,.jpg,.jpeg"
                          @change="onFileChange($event, 'urlLogo')"
                        />
                        <div
                          class="cuve cursor-pointer text-center border-2 d-flex align-items-center justify-content-center"
                          accept=".png,.peg,.jpg,.jpeg"
                          @drop="handleDrop($event, 'urlLogo')"
                          @dragover="handleDragover"
                          @dragenter="handleDragover"
                          @click="$refs.fileInputPhotoReference.click()"
                        >
                          <feather-icon
                            icon="UploadCloudIcon"
                            size="20"
                            svg-classes="h-16 w-16 stroke-current text-grey"
                          />
                          <span
                            class="ml-25"
                            @click.stop="$refs.fileInputPhotoReference.click()"
                            >{{ $t(label("Uploadimage")) }}
                          </span>
                        </div>
                      </div>
                      <template v-if="company.urlLogo" #aside>
                        <div class="image-full-screen">
                          <img
                            id="image"
                            ref="image"
                            :src="company.urlLogo"
                            class="img-avatar border-dashed"
                          />
                        </div>
                        <div
                          v-if="company.urlLogo && option != 2"
                          class="d-flex flex-wrap"
                          style="width: 10px"
                        >
                          <b-button
                            type="button"
                            variant="primary"
                            style="height: 30px; width: 30px; padding: 4px"
                            @click="deleteFile('urlLogo')"
                          >
                            <feather-icon icon="XIcon" size="21" />
                          </b-button>
                        </div>
                      </template>
                    </b-media>
                  </b-form-group>
                </b-col>

                <b-col cols="12" md="6" />

                <!-- Nombre de la empresa -->
                <b-col cols="12" md="6">
                  <b-form-group :label="$t(label('name'))" label-for="name">
                    <validation-provider
                      #default="{ errors }"
                      :name="$t(label('name'))"
                      rules="required"
                    >
                      <b-form-input
                        id="name"
                        v-model="company.name"
                        :state="errors.length > 0 ? false : null"
                        :placeholder="$t(label('name'))"
                        :disabled="!isSaveMode"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <!-- Correo electrónico de la empresa -->
                <b-col cols="12" md="6">
                  <validation-provider
                    #default="{ errors }"
                    :name="$t(label('email'))"
                    rules="required|email"
                  >
                    <b-form-group :label="$t(label('email'))" label-for="email">
                      <b-form-input
                        id="email"
                        v-model="company.email"
                        type="email"
                        :state="errors.length > 0 ? false : null"
                        :placeholder="$t(label('email'))"
                        :disabled="!isSaveMode"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>

                <!-- Pais de la empresa -->
                <b-col cols="12" md="6">
                  <validation-provider
                    #default="{ errors }"
                    :name="$t(label('country'))"
                    rules="required"
                  >
                    <b-form-group
                      :label="$t(label('country'))"
                      label-for="idCountrieSelected"
                      :state="errors.length > 0 ? false : null"
                    >
                      <v-select
                        ref="idCountrieSelected"
                        input-id="idCountrieSelected"
                        v-model="company.idCountry"
                        :options="listCountries"
                        label="name"
                        :placeholder="$t(label('country'))"
                        :disabled="!isSaveMode"
                        :reduce="(option) => option.idCountry"
                        @input="countryChanged"
                      >
                        <span slot="no-options">{{ $t("sorryOption") }}</span>
                      </v-select>
                      <b-form-invalid-feedback
                        :state="errors.length > 0 ? false : null"
                      >
                        {{ errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </b-col>

                <!-- Ciudad de la empresa -->
                <b-col cols="12" md="6">
                  <validation-provider
                    #default="{ errors }"
                    :name="$t(label('city'))"
                    rules="required"
                  >
                    <b-form-group
                      :label="$t(label('city'))"
                      label-for="idCitieSelected"
                      :state="errors.length > 0 ? false : null"
                    >
                      <v-select
                        ref="idCitieSelected"
                        v-model="company.idCity"
                        input-id="idCitieSelected"
                        :options="listCities"
                        label="name"
                        :placeholder="$t(label('city'))"
                        :disabled="option == 2 || company.idCountry == null"
                        :reduce="(option) => option.idCity"
                      >
                        <span slot="no-options">{{ $t("sorryOption") }}</span>
                      </v-select>
                      <b-form-invalid-feedback
                        :state="errors.length > 0 ? false : null"
                      >
                        {{ errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </b-col>

                <!-- telefono de la empresa -->
                <b-col cols="12" md="6">
                  <b-form-group
                    :label="$t(label('phone'))"
                    label-for="phoneNumber"
                  >
                    <vue-tel-input
                      inputId="phoneNumber"
                      name="phoneNumber"
                      v-model="company.phoneNumber"
                      :disabled="!isSaveMode"
                      :mode="'international'"
                      defaultCountry="ve"
                      :disabledFetchingCountry="true"
                      :inputOptions="inputTelOption"
                      @open="onDropdownOpen(true)"
                      @close="onDropdownOpen(false)"
                    >
                      <template v-slot:arrow-icon>
                        <span>{{ openTelInput ? "▲" : "▼" }}</span>
                      </template>
                    </vue-tel-input>
                  </b-form-group>
                </b-col>

                <!-- Dirección de la empresa -->
                <b-col cols="12" md="6">
                  <b-form-group
                    :label="$t(label('address'))"
                    label-for="address"
                  >
                    <b-form-input
                      id="address"
                      v-model="company.address"
                      :placeholder="$t(label('address'))"
                      :disabled="!isSaveMode"
                    />
                  </b-form-group>
                </b-col>

                <!-- Hora de apertura de la empresa -->
                <b-col cols="12" md="6">
                  <b-form-group
                    :label="$t(label('hourOpening'))"
                    label-for="hourOpening"
                  >
                    <validation-provider
                      #default="{ errors }"
                      :name="$t(label('hourOpening'))"
                      rules="required"
                    >
                      <b-form-input
                        id="hourOpening"
                        type="time"
                        v-model="company.workingHoursFrom"
                        :placeholder="$t(label('hourOpening'))"
                        :state="errors.length > 0 ? false : null"
                        :disabled="!isSaveMode"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <!-- Hora de apertura de la empresa -->
                <b-col cols="12" md="6">
                  <b-form-group
                    :label="$t(label('hourClosing'))"
                    label-for="hourClosing"
                  >
                    <validation-provider
                      #default="{ errors }"
                      :name="$t(label('hourClosing'))"
                      rules="required"
                    >
                      <b-form-input
                        id="hourClosing"
                        type="time"
                        v-model="company.workingHoursTo"
                        :placeholder="$t(label('hourClosing'))"
                        :state="errors.length > 0 ? false : null"
                        :disabled="!isSaveMode"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <!-- nombre del contacto de la empresa -->
                <b-col cols="12" md="6">
                  <b-form-group
                    :label="$t(label('nameContact'))"
                    label-for="contactPersonName"
                  >
                    <b-form-input
                      id="contactPersonName"
                      v-model="company.contactPersonName"
                      :placeholder="$t(label('nameContact'))"
                      :disabled="!isSaveMode"
                    />
                  </b-form-group>
                </b-col>

                <!-- Correo electrónico del contacto de la empresa -->
                <b-col cols="12" md="6">
                  <b-form-group
                    :label="$t(label('emailContact'))"
                    label-for="emailContact"
                  >
                    <b-form-input
                      id="emailContact"
                      v-model="company.contactPersonEmail"
                      type="email"
                      :placeholder="$t(label('emailContact'))"
                      :disabled="!isSaveMode"
                    />
                  </b-form-group>
                </b-col>

                <!-- Número de teléfono del contacto de la empresa -->
                <b-col cols="12" md="6">
                  <b-form-group
                    :label="$t(label('phoneContact'))"
                    label-for="contactPersonPhoneNumber"
                  >
                    <vue-tel-input
                      inputId="contactPersonPhoneNumber"
                      name="contactPersonPhoneNumber"
                      v-model="company.contactPersonPhoneNumber"
                      :disabled="!isSaveMode"
                      :mode="'international'"
                      defaultCountry="ve"
                      :disabledFetchingCountry="true"
                      :inputOptions="inputTelOption"
                      @open="onDropdownOpen(true)"
                      @close="onDropdownOpen(false)"
                    >
                      <template v-slot:arrow-icon>
                        <span>{{ openTelInput ? "▲" : "▼" }}</span>
                      </template>
                    </vue-tel-input>
                  </b-form-group>
                </b-col>

                <b-col cols="12" md="6" />

                <!-- IVA de la empresa -->
                <b-col cols="12" md="6">
                  <b-form-group :label="$t(label('iva'))" label-for="iva">
                    <b-form-input
                      id="iva"
                      v-model="company.iva"
                      type="number"
                      @input="notDecimal"
                      :placeholder="$t(label('iva'))"
                      :disabled="!isSaveMode"
                      min="1"
                      max="100"
                      step="1"
                    />
                  </b-form-group>
                </b-col>

                <!-- Tasa del dólar BCV de la empresa -->
                <b-col cols="12" md="6">
                  <div class="d-flex align-items-center">
                    <label class="m-0">
                      {{ $t(label("dollarBCV")) }}
                    </label>
                    <b-form-checkbox
                      id="dolarBCV"
                      v-model="company.dolarBCV"
                      switch
                      inline
                    >
                    </b-form-checkbox>

                    <b-form-group
                      :label="$t(label('dollarRate'))"
                      label-for="tasaDolar"
                    >
                      <b-form-input
                        id="tasaDolar"
                        v-model="company.tasaDolar"
                        :placeholder="$t(label('dollarRate'))"
                        :disabled="!isSaveMode"
                        type="number"
                        min="1"
                      />
                    </b-form-group>

                    <p class="mb-0 pl-1" style="opacity: 0.6">
                      {{ $t(label("suggestedDollarRate")) }} <br />
                      {{ dolarToday }} {{ "BsF." }}
                    </p>
                  </div>
                </b-col>

                <!-- Requieres conexión de la empresa -->
                <b-col cols="12" md="6">
                  <b-form-group :label="$t(label('databaseConnection'))">
                    <b-form-radio-group
                      id="connectDatabase"
                      v-model="company.connectDatabase"
                      :options="listConnectDatabase"
                      :disabled="!isSaveMode"
                    ></b-form-radio-group>
                  </b-form-group>
                </b-col>

                <b-col cols="12" md="6" />

                <!-- Documento de la empresa -->
                <b-col
                  v-if="option != 2"
                  cols="12"
                  md="6"
                  class="d-flex align-items-center justify-content-center"
                >
                  <b-form-group
                    :label="$t(label('document'))"
                    label-for="inputFileDocument"
                  >
                    <b-media class="body-style">
                      <div v-if="!company.urlPdf && option != 2">
                        <input
                          id="inputFileDocument"
                          ref="fileInputDocument"
                          name="inputFileDocument"
                          type="file"
                          class="hidden"
                          accept="application/pdf"
                          @change="onFileChange($event, 'urlPdf')"
                        />
                        <div
                          class="cuve cursor-pointer text-center border-2 d-flex align-items-center justify-content-center"
                          accept="application/pdf"
                          @drop="handleDrop($event, 'urlPdf')"
                          @dragover="handleDragover"
                          @dragenter="handleDragover"
                          @click="$refs.fileInputDocument.click()"
                        >
                          <feather-icon
                            icon="UploadCloudIcon"
                            size="20"
                            svg-classes="h-16 w-16 stroke-current text-grey"
                          />
                          <span
                            style="margin-left: 5px"
                            @click.stop="$refs.fileInputDocument.click()"
                            >{{ $t("Uploaddocument") }}
                          </span>
                        </div>
                      </div>

                      <template v-if="company.urlPdf" #aside>
                        <div
                          v-if="company.urlPdf && option != 2"
                          class="d-flex flex-wrap"
                          style="width: 10px"
                        >
                          <b-button
                            variant="primary"
                            style="height: 30px; width: 30px; padding: 4px"
                            @click="deleteFile('urlPdf')"
                          >
                            <feather-icon icon="XIcon" size="21" />
                          </b-button>
                          <b-link
                            class="ml-25 text-info"
                            :href="company.urlPdf"
                            target="_blank"
                          >
                            <feather-icon icon="FileTextIcon" size="250" />
                          </b-link>
                        </div>
                      </template>
                    </b-media>
                  </b-form-group>
                </b-col>

                <!-- Catálogo de la empresa -->
                <b-col
                  v-if="option != 2"
                  cols="12"
                  md="6"
                  class="d-flex align-items-center justify-content-center"
                >
                  <b-form-group
                    :label="$t(label('catalogue'))"
                    label-for="inputCatalogDocument"
                  >
                    <b-media class="body-style">
                      <div v-if="!company.urlPdfCatalogProducts && option != 2">
                        <input
                          id="inputCatalogDocument"
                          ref="catalogInputDocument"
                          name="inputCatalogDocument"
                          type="file"
                          class="hidden"
                          accept="application/pdf"
                          @change="
                            onFileChange($event, 'urlPdfCatalogProducts')
                          "
                        />
                        <div
                          class="cuve cursor-pointer text-center border-2 d-flex align-items-center justify-content-center"
                          accept="application/pdf"
                          @drop="handleDrop($event, 'urlPdfCatalogProducts')"
                          @dragover="handleDragover"
                          @dragenter="handleDragover"
                          @click="$refs.catalogInputDocument.click()"
                        >
                          <feather-icon
                            icon="UploadCloudIcon"
                            size="20"
                            svg-classes="h-16 w-16 stroke-current text-grey"
                          />
                          <span
                            style="margin-left: 5px"
                            @click.stop="$refs.catalogInputDocument.click()"
                            >{{ $t("Uploadcatalog") }}
                          </span>
                        </div>
                      </div>

                      <template v-if="company.urlPdfCatalogProducts" #aside>
                        <div
                          v-if="company.urlPdfCatalogProducts && option != 2"
                          class="d-flex flex-wrap"
                          style="width: 10px"
                        >
                          <b-button
                            variant="primary"
                            style="height: 30px; width: 30px; padding: 4px"
                            @click="deleteFile('urlPdfCatalogProducts')"
                          >
                            <feather-icon icon="XIcon" size="21" />
                          </b-button>
                          <b-link
                            class="ml-25 text-info"
                            :href="company.urlPdfCatalogProducts"
                            target="_blank"
                          >
                            <feather-icon icon="FileTextIcon" size="250" />
                          </b-link>
                        </div>
                      </template>
                    </b-media>
                  </b-form-group>
                </b-col>

                <b-col cols="12"> <hr /> </b-col>

                <!-- Redes sociales de la empresa -->
                <b-col cols="12" md="6">
                  <b-form-group label="Facebook" label-for="facebook">
                    <b-form-input
                      id="facebook"
                      v-model="company.facebook"
                      type="text"
                      placeholder="https://facebook.com/"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                  <b-form-group label="X" label-for="x">
                    <b-form-input
                      id="x"
                      v-model="company.x"
                      type="text"
                      placeholder="https://x.com/"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                  <b-form-group label="Instagram" label-for="instagram">
                    <b-form-input
                      id="instagram"
                      v-model="company.instagram"
                      type="text"
                      placeholder="https://instagram.com/"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                  <b-form-group label="Linkedin" label-for="linkedin">
                    <b-form-input
                      id="linkedin"
                      v-model="company.linkedin"
                      type="text"
                      placeholder="https://linkedin.com/"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                  <b-form-group label="Whatsapp" label-for="whatsapp">
                    <b-form-input
                      id="whatsapp"
                      v-model="company.whatsapp"
                      type="text"
                      placeholder="https://whatsapp.com/"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                  <b-form-group label="Telegram" label-for="telegram">
                    <b-form-input
                      id="telegram"
                      v-model="company.telegram"
                      type="text"
                      placeholder="https://telegram.com/"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                  <b-form-group label="Tiktok" label-for="tiktok">
                    <b-form-input
                      id="tiktok"
                      v-model="company.tiktok"
                      type="text"
                      placeholder="https://tiktok.com/"
                    />
                  </b-form-group>
                </b-col>

                <b-col cols="12"> <hr /> </b-col>

                <!-- Preguntas frecuentes de la empresa -->
                <b-col cols="12" md="6">
                  <h5>{{ $t("frequentlyQuestions") }}</h5>
                </b-col>

                <b-col cols="12">
                  <b-row
                    v-for="(item, index) in frequentQuestions"
                    :id="item.uuid"
                    :key="item.uuid"
                    ref="row"
                  >
                    <b-col cols="12" md="5">
                      <b-form-group
                        :label="$t(label('question'))"
                        :label-for="`question-${index}`"
                      >
                        <b-form-textarea
                          :id="`question-${index}`"
                          v-model="item.question"
                          :placeholder="$t(label('question'))"
                          :disabled="!isSaveMode"
                          rows="3"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" md="5">
                      <b-form-group
                        :label="$t(label('answer'))"
                        :label-for="`answer-${index}`"
                      >
                        <b-form-textarea
                          :id="`answer-${index}`"
                          v-model="item.answer"
                          :placeholder="$t(label('answer'))"
                          :disabled="!isSaveMode"
                          rows="3"
                        />
                      </b-form-group>
                    </b-col>

                    <!-- Remove Button -->
                    <b-col v-if="option != 2" cols="12" md="2">
                      <b-button
                        v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                        variant="outline-danger"
                        class="mt-0 mt-md-2"
                        @click="removeItem(index)"
                      >
                        <feather-icon icon="XIcon" class="mr-25" />
                        <span>{{ $t("delete") }}</span>
                      </b-button>
                    </b-col>
                  </b-row>
                </b-col>

                <b-col v-if="option != 2" cols="12">
                  <b-button
                    type="button"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    @click="repeateAgain"
                  >
                    <feather-icon icon="PlusIcon" class="mr-25" />
                    <span>{{ $t("add") }}</span>
                  </b-button>
                </b-col>
              </b-row>
            </b-form>
          </validation-observer>
        </tab-content>

        <!-- Metodos de pagos de la empresa :before-change="validationPayCompany"-->
        <tab-content
          :title="$t('pages.companies.payCompanies')"
          ref="formPayCompany"
        >
          <b-row>
            <!-- Método de pago de la empresa -->
            <b-col cols="12" md="6" v-if="option != 2">
              <b-form-group :label="$t(label('pay'))" label-for="pay">
                <v-select
                  ref="pay"
                  v-model="payMethod"
                  input-id="pay"
                  :options="listMethodPays"
                  label="name"
                  :placeholder="$t(label('pay'))"
                  :reduce="(option) => option"
                >
                  <span slot="no-options">{{ $t("sorryOption") }}</span>
                </v-select>
              </b-form-group>
            </b-col>

            <!-- Información de pago de la empresa -->
            <b-col cols="12" md="6" v-if="option != 2">
              <b-form-group
                :label="$t(label('information'))"
                label-for="information"
              >
                <b-form-textarea
                  id="information"
                  v-model="information"
                  :placeholder="$t(label('information'))"
                  :disabled="!isSaveMode"
                  rows="3"
                />
              </b-form-group>
            </b-col>

            <b-col class="d-flex justify-content-end" cols="12">
              <b-button
                v-if="option != 2"
                type="button"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                @click="addPay"
              >
                <feather-icon icon="PlusIcon" class="mr-25" />
                <span>{{ $t("add") }}</span>
              </b-button>
            </b-col>

            <!-- pay-company la empresa -->
            <b-col class="mt-1" cols="12">
              <b-table
                id="pay-company-table"
                responsive
                :head-variant="headVariant"
                :striped="striped"
                :bordered="bordered"
                :borderless="borderless"
                :outlined="outlined"
                :per-page="perPage"
                :busy="loading"
                :items="company.paymentMethods"
                :fields="payFields"
                class="d-none d-md-table shadow-sm !rounded"
              >
                <template #head()="data">
                  <span class="text-black">{{
                    $t(labelHeader(data.label.toLowerCase()))
                  }}</span>
                </template>

                <template #cell(nameType)="data">
                  <slot name="cell-nameType" :data="data">
                    {{ data.item.nameType || "N/A" }}
                  </slot>
                </template>

                <template #cell(information)="data">
                  <slot name="cell-information" :data="data">
                    {{ data.item.information || "N/A" }}
                  </slot>
                </template>

                <template #cell(actions)="data" v-if="option != 2">
                  <feather-icon
                    class="text-danger"
                    size="18"
                    icon="Trash2Icon"
                    @click="onDeletePay(data.item)"
                  />
                </template>
              </b-table>

              <!-- List for mobile devices -->
              <div
                id="list-container"
                class="d-block d-md-none mt-1 list-container"
              >
                <b-list-group>
                  <b-list-group-item
                    v-for="(item, key) in company.paymentMethods"
                    :key="key"
                    class="d-flex flex-column align-items-start border border-primary rounded mb-1"
                  >
                    <div class="d-flex w-100 justify-content-between mb-1">
                      <strong> {{ $t(labelHeader("name")) }}: </strong
                      >{{ item.nameType || "N/A" }}
                      <b-dropdown
                        variant="link"
                        no-caret
                        class="chart-dropdown"
                        toggle-class="p-0"
                        right
                      >
                        <template #button-content>
                          <feather-icon
                            icon="MoreVerticalIcon"
                            size="18"
                            class="text-body cursor-pointer"
                          />
                        </template>
                        <b-dropdown-item @click="onDeletePay(item)">
                          <div
                            class="d-flex align-items-center justify-content-between"
                          >
                            <feather-icon
                              class="text-danger"
                              size="18"
                              icon="Trash2Icon"
                            />
                            {{ $t("delete") }}
                          </div>
                        </b-dropdown-item>
                      </b-dropdown>
                    </div>
                    <p class="m-0">
                      <strong>{{ $t(labelHeader("information")) }}: </strong>
                      {{ item.information || "N/A" }}
                    </p>
                  </b-list-group-item>
                  <b-list-group-item
                    v-if="company.paymentMethods.length == 0"
                    class="text-center"
                  >
                    {{ $t("notRegister") }}
                  </b-list-group-item>
                  <b-list-group-item v-if="loading" class="text-center">
                    <b-spinner
                      class="align-middle ml-50"
                      variant="primary"
                    ></b-spinner>
                  </b-list-group-item>
                </b-list-group>
              </div>
            </b-col>
          </b-row>
        </tab-content>

        <!-- Servicio de envíos de la empresa :before-change="validationDeliveryCompany"-->
        <tab-content
          :title="$t('pages.companies.deliveryCompanies')"
          ref="formDeliveryCompany"
        >
          <b-row>
            <!-- Zona de envio de la empresa -->
            <b-col cols="12" md="6" v-if="option != 2">
              <b-form-group
                :label="$t(label('deliveryZone'))"
                label-for="deliveryZone"
              >
                <v-select
                  ref="deliveryZone"
                  v-model="zonaCatalog"
                  input-id="deliveryZone"
                  :options="listDaliveryZones"
                  label="name"
                  :placeholder="$t(label('deliveryZone'))"
                  :reduce="(option) => option"
                >
                  <span slot="no-options">{{ $t("sorryOption") }}</span>
                </v-select>
              </b-form-group>
            </b-col>

            <!-- Monto de envio de la empresa -->
            <b-col cols="12" md="6" v-if="option != 2">
              <b-form-group :label="$t(label('amount'))" label-for="amount">
                <b-form-input
                  id="amount"
                  v-model="amount"
                  type="number"
                  @input="numberValidate"
                  :disabled="option === 2 ? true : false"
                  :placeholder="$t(label('amount'))"
                />
              </b-form-group>
            </b-col>

            <b-col class="d-flex justify-content-end" cols="12">
              <b-button
                v-if="option != 2"
                type="button"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                @click="addDelivery"
              >
                <feather-icon icon="PlusIcon" class="mr-25" />
                <span>{{ $t("add") }}</span>
              </b-button>
            </b-col>

            <b-col class="mt-1" cols="12">
              <b-table
                id="delivery-table"
                responsive
                :head-variant="headVariant"
                :striped="striped"
                :bordered="bordered"
                :borderless="borderless"
                :outlined="outlined"
                :per-page="perPage"
                :busy="loading"
                :items="company.deliveryCosts"
                :fields="deliveryFields"
                class="d-none d-md-table shadow-sm !rounded"
              >
                <template #head()="data">
                  <span class="text-black">{{
                    $t(labelHeader(data.label.toLowerCase()))
                  }}</span>
                </template>

                <template #cell(nameCatZona)="data">
                  <slot name="cell-nameCatZona" :data="data">
                    {{ data.item.nameCatZona || "N/A" }}
                  </slot>
                </template>

                <template #cell(startTime)="data">
                  <slot name="cell-startTime" :data="data">
                    {{ data.item.startTime || "N/A" }}
                  </slot>
                </template>

                <template #cell(amount)="data">
                  <slot name="cell-amount" :data="data">
                    {{ data.item.amount || "N/A" }}
                  </slot>
                </template>
                <template #cell(endTime)="data">
                  <slot name="cell-endTime" :data="data">
                    {{ data.item.endTime || "N/A" }}
                  </slot>
                </template>

                <template #cell(actions)="data" v-if="option != 2">
                  <feather-icon
                    class="text-danger"
                    size="18"
                    icon="Trash2Icon"
                    @click="onDeleteDelivery(data.item)"
                  />
                </template>
              </b-table>

              <!-- List for mobile devices -->
              <div
                id="list-container"
                class="d-block d-md-none mt-1 list-container"
              >
                <b-list-group>
                  <b-list-group-item
                    v-for="(item, key) in company.deliveryCosts"
                    :key="key"
                    class="d-flex flex-column align-items-start border border-primary rounded mb-1"
                  >
                    <div class="d-flex w-100 justify-content-between mb-1">
                      <strong> {{ $t(labelHeader("zona")) }}: </strong
                      >{{ item.nameCatZona || "N/A" }}
                      <b-dropdown
                        variant="link"
                        no-caret
                        class="chart-dropdown"
                        toggle-class="p-0"
                        right
                      >
                        <template #button-content>
                          <feather-icon
                            icon="MoreVerticalIcon"
                            size="18"
                            class="text-body cursor-pointer"
                          />
                        </template>
                        <b-dropdown-item @click="onDeleteDelivery(item)">
                          <div
                            class="d-flex align-items-center justify-content-between"
                          >
                            <feather-icon
                              class="text-danger"
                              size="18"
                              icon="Trash2Icon"
                            />
                            {{ $t("delete") }}
                          </div>
                        </b-dropdown-item>
                      </b-dropdown>
                    </div>
                    <p class="m-0">
                      <strong>{{ $t(labelHeader("city")) }}: </strong>
                      {{ item.nameCity || "N/A" }}
                    </p>
                    <p class="m-0">
                      <strong>{{ $t(labelHeader("amount")) }}: </strong>
                      {{ item.amount || "N/A" }}
                    </p>
                  </b-list-group-item>
                  <b-list-group-item
                    v-if="company.deliveryCosts.length == 0"
                    class="text-center"
                  >
                    {{ $t("notRegister") }}
                  </b-list-group-item>
                  <b-list-group-item v-if="loading" class="text-center">
                    <b-spinner
                      class="align-middle ml-50"
                      variant="primary"
                    ></b-spinner>
                  </b-list-group-item>
                </b-list-group>
              </div>
            </b-col>
          </b-row>
        </tab-content>

        <!-- Horarios de atención de la empresa :before-change="validationWorkSchedules"-->
        <tab-content
          :title="$t('pages.companies.workSchedules')"
          ref="formWorkSchedules"
        >
          <b-row>
            <!-- Día de atención de la empresa -->
            <b-col cols="12" md="4" v-if="option != 2">
              <b-form-group :label="$t(label('day'))" label-for="day">
                <v-select
                  ref="day"
                  v-model="catDay"
                  input-id="day"
                  :options="allDays"
                  label="name"
                  :placeholder="$t(label('day'))"
                  :reduce="(option) => option"
                >
                  <span slot="no-options">{{ $t("sorryOption") }}</span>
                </v-select>
              </b-form-group>
            </b-col>

            <!-- Inicio de atención de la empresa -->
            <b-col cols="12" md="4" v-if="option != 2">
              <b-form-group
                :label="$t(label('startTime'))"
                label-for="startTime"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t(label('startTime'))"
                  :rules="{
                    isBefore: {
                      targetField: $t(label('endTime')),
                      targetValue: endTime,
                    },
                  }"
                >
                  <b-form-timepicker
                    id="startTime"
                    ref="startTime"
                    v-model="startTime"
                    :placeholder="$t(label('startTime'))"
                    :state="errors.length > 0 ? false : null"
                    reset-button
                    :disabled="!isSaveMode"
                    dropright
                  >
                  </b-form-timepicker>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <!-- Fin de atención de la empresa -->
            <b-col cols="12" md="4" v-if="option != 2">
              <b-form-group :label="$t(label('endTime'))" label-for="endTime">
                <validation-provider
                  #default="{ errors }"
                  :name="$t(label('endTime'))"
                  :rules="{
                    isAfter: {
                      targetField: $t(label('startTime')),
                      targetValue: startTime,
                    },
                  }"
                >
                  <b-form-timepicker
                    id="endTime"
                    ref="endTime"
                    v-model="endTime"
                    :placeholder="$t(label('endTime'))"
                    :state="errors.length > 0 ? false : null"
                    reset-button
                    :disabled="!isSaveMode"
                    dropright
                  >
                  </b-form-timepicker>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <!-- Inicio de descanso de la empresa -->
            <b-col cols="12" md="4" v-if="option != 2">
              <b-form-group
                :label="$t(label('timeBreakStart'))"
                label-for="timeBreakStart"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t(label('timeBreakStart'))"
                  :rules="{
                    isBefore: {
                      targetField: $t(label('timeBreakEnd')),
                      targetValue: timeBreakEnd,
                    },
                  }"
                >
                  <b-form-timepicker
                    id="timeBreakStart"
                    ref="timeBreakStart"
                    v-model="timeBreakStart"
                    :placeholder="$t(label('timeBreakStart'))"
                    :state="errors.length > 0 ? false : null"
                    reset-button
                    :disabled="!isSaveMode"
                    dropright
                  >
                  </b-form-timepicker>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <!-- Fin de descanso de la empresa -->
            <b-col cols="12" md="4" v-if="option != 2">
              <b-form-group
                :label="$t(label('timeBreakEnd'))"
                label-for="timeBreakEnd"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t(label('timeBreakEnd'))"
                  :rules="{
                    isAfter: {
                      targetField: $t(label('timeBreakStart')),
                      targetValue: timeBreakStart,
                    },
                  }"
                >
                  <b-form-timepicker
                    id="timeBreakEnd"
                    ref="timeBreakEnd"
                    v-model="timeBreakEnd"
                    :placeholder="$t(label('timeBreakEnd'))"
                    :state="errors.length > 0 ? false : null"
                    reset-button
                    :disabled="!isSaveMode"
                    dropright
                  >
                  </b-form-timepicker>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <!-- Descripción de atención de la empresa -->
            <b-col cols="12" md="4" v-if="option != 2">
              <b-form-group
                :label="$t(label('description'))"
                label-for="description"
              >
                <b-form-textarea
                  id="description"
                  :placeholder="$t(label('description'))"
                  v-model="description"
                  :disabled="!isSaveMode"
                  rows="3"
                />
              </b-form-group>
            </b-col>

            <b-col class="d-flex justify-content-end" cols="12">
              <b-button
                v-if="option != 2"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                type="button"
                @click="addSchedules"
              >
                <feather-icon icon="PlusIcon" class="mr-25" />
                <span>{{ $t("add") }}</span>
              </b-button>
            </b-col>

            <b-col class="mt-1" cols="12">
              <b-table
                id="schedules-table"
                responsive
                :striped="striped"
                :bordered="bordered"
                :borderless="borderless"
                :outlined="outlined"
                :per-page="perPage"
                :busy="loading"
                :items="company.workSchedules"
                :fields="schedulesFields"
                class="d-none d-md-table shadow-sm !rounded"
              >
                <template #head()="data">
                  <span class="text-black">{{
                    $t(labelHeader(data.label.toLowerCase()))
                  }}</span>
                </template>

                <template #cell(nameDay)="data">
                  <slot name="cell-nameDay" :data="data">
                    {{ data.item.nameDay || "N/A" }}
                  </slot>
                </template>

                <template #cell(startTime)="data">
                  <slot name="cell-startTime" :data="data">
                    {{
                      data.item.startTime != null
                        ? formattedTime(data.item.startTime)
                        : "N/A"
                    }}
                  </slot>
                </template>

                <template #cell(endTime)="data">
                  <slot name="cell-endTime" :data="data">
                    {{
                      data.item.endTime != null
                        ? formattedTime(data.item.endTime)
                        : "N/A"
                    }}
                  </slot>
                </template>

                <template #cell(timeBreakStart)="data">
                  <slot name="cell-timeBreakStart" :data="data">
                    {{
                      data.item.timeBreakStart != null
                        ? formattedTime(data.item.timeBreakStart)
                        : "N/A"
                    }}
                  </slot>
                </template>

                <template #cell(timeBreakEnd)="data">
                  <slot name="cell-timeBreakEnd" :data="data">
                    {{
                      data.item.timeBreakEnd != null
                        ? formattedTime(data.item.timeBreakEnd)
                        : "N/A"
                    }}
                  </slot>
                </template>

                <template #cell(description)="data">
                  <slot name="cell-description" :data="data">
                    {{ data.item.description || "N/A" }}
                  </slot>
                </template>

                <template #cell(actions)="data" v-if="option != 2">
                  <feather-icon
                    class="text-danger"
                    size="18"
                    icon="Trash2Icon"
                    @click="onDeleteSchedules(data.item)"
                  />
                </template>
              </b-table>

              <!-- List for mobile devices -->
              <div
                id="list-container"
                class="d-block d-md-none mt-1 list-container"
              >
                <b-list-group>
                  <b-list-group-item
                    v-for="(item, key) in company.workSchedules"
                    :key="key"
                    class="d-flex flex-column align-items-start border border-primary rounded mb-1"
                  >
                    <div class="d-flex w-100 justify-content-between mb-1">
                      <strong> {{ $t(labelHeader("day")) }}: </strong
                      >{{ item.nameDay || "N/A" }}
                      <b-dropdown
                        variant="link"
                        no-caret
                        class="chart-dropdown"
                        toggle-class="p-0"
                        right
                      >
                        <template #button-content>
                          <feather-icon
                            icon="MoreVerticalIcon"
                            size="18"
                            class="text-body cursor-pointer"
                          />
                        </template>
                        <b-dropdown-item @click="onDeleteDelivery(item)">
                          <div
                            class="d-flex align-items-center justify-content-between"
                          >
                            <feather-icon
                              class="text-danger"
                              size="18"
                              icon="Trash2Icon"
                            />
                            {{ $t("delete") }}
                          </div>
                        </b-dropdown-item>
                      </b-dropdown>
                    </div>
                    <p class="m-0">
                      <strong>{{ $t(labelHeader("starttime")) }}: </strong>
                      {{
                        item.startTime != null
                          ? formattedTime(item.startTime)
                          : "N/A"
                      }}
                    </p>
                    <p class="m-0">
                      <strong>{{ $t(labelHeader("endtime")) }}: </strong>
                      {{
                        item.endTime != null
                          ? formattedTime(item.endTime)
                          : "N/A"
                      }}
                    </p>
                    <p class="m-0">
                      <strong>{{ $t(labelHeader("timebreakstart")) }}: </strong>
                      {{
                        item.timeBreakStart != null
                          ? formattedTime(item.timeBreakStart)
                          : "N/A"
                      }}
                    </p>
                    <p class="m-0">
                      <strong>{{ $t(labelHeader("timereakend")) }}: </strong>
                      {{
                        item.timeBreakEnd != null
                          ? formattedTime(item.timeBreakEnd)
                          : "N/A"
                      }}
                    </p>
                    <p class="m-0">
                      <strong>{{ $t(labelHeader("description")) }}: </strong>
                      {{ item.description || "N/A" }}
                    </p>
                  </b-list-group-item>
                  <b-list-group-item
                    v-if="company.workSchedules.length == 0"
                    class="text-center"
                  >
                    {{ $t("notRegister") }}
                  </b-list-group-item>
                  <b-list-group-item v-if="loading" class="text-center">
                    <b-spinner
                      class="align-middle ml-50"
                      variant="primary"
                    ></b-spinner>
                  </b-list-group-item>
                </b-list-group>
              </div>
            </b-col>
          </b-row>
        </tab-content>

        <!-- Botones de navegación -->
        <template slot="footer" slot-scope="props">
          <div class="wizard-footer-left">
            <wizard-button
              v-if="props.activeTabIndex > 0 && !props.isLastStep"
              @click.native="props.prevTab()"
              :style="props.fillButtonStyle"
            >
              {{ $t("back") }}
            </wizard-button>

            <wizard-button
              v-else-if="props.activeTabIndex > 0 && props.isLastStep"
              @click.native="props.prevTab()"
              :style="props.fillButtonStyle"
            >
              {{ $t("back") }}
            </wizard-button>
          </div>
          <div class="wizard-footer-right">
            <wizard-button
              v-if="!props.isLastStep"
              @click.native="props.nextTab()"
              class="wizard-footer-right"
              :style="props.fillButtonStyle"
            >
              {{ $t("following") }}
            </wizard-button>

            <wizard-button
              v-else-if="option != 2"
              @click.native="onSubmit"
              class="wizard-footer-right finish-button"
              :style="props.fillButtonStyle"
            >
              {{ props.isLastStep ? $t("save") : $t("following") }}
            </wizard-button>
          </div>
        </template>
      </form-wizard>
    </b-card-body>
  </b-card>
</template>

<script>
import _ from "lodash";
import { heightTransition } from "@core/mixins/ui/transition";
import { FormWizard, TabContent, WizardButton } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import vSelect from "vue-select";
import { VueTelInput } from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";
import vueJsonEditor from "vue-json-editor";
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BFormGroup,
  BForm,
  BFormTextarea,
  BFormRadioGroup,
  BFormRadio,
  BFormInvalidFeedback,
  BFormTimepicker,
  BFormCheckbox,
  BListGroup,
  BListGroupItem,
  BDropdown,
  BDropdownItem,
  BSpinner,
} from "bootstrap-vue";
import {
  ValidationProvider,
  ValidationObserver,
  localize,
  extend,
} from "vee-validate";
import Ripple from "vue-ripple-directive";
import { required } from "@validations";
import moment from "moment";
import router from "@/router";
import {
  createOrEditCompany,
  getCompany,
  deletePaymentMethods,
  deleteHoursMethods,
  createOrEditSucursal,
} from "@core/api/request/company";
import { allCountries, allCities } from "@core/api/request/countries";
import {
  getCatalog,
  postFile,
  getDolarToday,
} from "@core/api/request/catalogs";
import { getParams, showLoading, stopLoading } from "@core/utils/utils";

extend("isBefore", {
  params: ["targetField", "targetValue"],
  validate(value, { targetValue }) {
    if (!targetValue) return true;
    return value < targetValue;
  },
  message:
    "{_field_} debe ser menor que {targetField} y no pueden ser iguales.",
});

extend("isAfter", {
  params: ["targetField", "targetValue"],
  validate(value, { targetValue }) {
    if (!targetValue) return true;
    return value > targetValue;
  },
  message:
    "{_field_} debe ser mayor que {targetField} y no pueden ser iguales.",
});

const companyTypeTemplate = {
  guid: null,
  idCatSize: null,
  idCatActivity: null,
  idCatGeographicAreaOfOperation: null,
  idCatCompanyOwnership: null,
  businessContext: null,
  idCatCoinType: null,
  jsonFunction: {},
};

const companyTemplate = {
  guidCompanyPadre: null,
  guid: null,
  companyType: null,
  name: null,
  email: null,
  idCountry: null,
  idCity: null,
  address: null,
  phoneNumber: "",
  contactPersonName: null,
  contactPersonEmail: null,
  contactPersonPhoneNumber: "",
  workingHoursFrom: null,
  workingHoursTo: null,
  urlLogo: null,
  urlPdf: null,
  urlPdfCatalogProducts: null,
  connectDatabase: false,
  frequentQuestions: [],
  paymentMethods: [],
  deliveryCosts: [],
  workSchedules: [],
  productsAndServices: false,
  productss: false,
  servicess: false,
  informativo: false,
  servicesProfessional: false,
  reservations: false,
  tasaDolar: 0,
  iva: 0,
  dolarBCV: true,
  facebook: null,
  x: null,
  instagram: null,
  linkedin: null,
  whatsapp: null,
  telegram: null,
  tiktok: null,
};
const companyTemplateFather = {
  guid: null,
  companyType: null,
  name: null,
  email: null,
};

export default {
  components: {
    FormWizard,
    TabContent,
    WizardButton,
    BFormInvalidFeedback,
    vSelect,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BFormGroup,
    BForm,
    BFormTextarea,
    BFormRadioGroup,
    BFormRadio,
    ValidationProvider,
    ValidationObserver,
    VueTelInput,
    BFormTimepicker,
    vueJsonEditor,
    BFormCheckbox,
    BListGroup,
    BListGroupItem,
    BDropdown,
    BDropdownItem,
    BSpinner,
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  data: () => ({
    loading: false,
    isSaveMode: true,
    company: Object.assign(companyTemplate),
    companyFather: Object.assign(companyTemplateFather),
    companyType: Object.assign(companyTypeTemplate),
    option: "",
    required,
    perPage: 50,
    headVariant: "light",
    striped: false,
    outlined: false,
    bordered: true,
    borderless: true,
    payFields: [
      { label: "name", key: "nameType", sortable: false },
      { label: "information", key: "information", sortable: false },
      { label: "action", key: "actions", sortable: false },
    ],
    deliveryFields: [
      { label: "zona", key: "nameCatZona", sortable: false },
      { label: "city", key: "nameCity", sortable: false },
      { label: "amount", key: "amount", sortable: false },
      { label: "action", key: "actions", sortable: false },
    ],
    schedulesFields: [
      { label: "day", key: "nameDay", sortable: false },
      { label: "starttime", key: "startTime", sortable: false },
      { label: "endtime", key: "endTime", sortable: false },
      { label: "timebreakstart", key: "timeBreakStart", sortable: false },
      { label: "timereakend", key: "timeBreakEnd", sortable: false },
      { label: "description", key: "description", sortable: false },
      { label: "action", key: "actions", sortable: false },
    ],
    selected: null, // Must be an array reference!
    listCatSizes: [],
    listDaliveryZones: [],
    listCatGeographic: [],
    listCatCompany: [],
    listCoinTypes: [],
    listCountries: [],
    listCities: [],
    listMethodPays: [],
    listConnectDatabase: [
      { text: "Sí", value: true },
      { text: "No", value: false },
    ],
    zonaCatalog: null,
    amount: 0,
    payMethod: null,
    information: null,
    frequentQuestions: [],
    nextTodoId: 1,
    phoneNumber: "",
    dolarToday: 0,
    openTelInput: false,
    itemsPage: 1,
    itemsRows: 999,
    inputTelOption: {
      placeholder: "Ingrese un número de teléfono",
    },
    allDays: [],
    catDay: null,
    startTime: null,
    endTime: null,
    timeBreakStart: null,
    timeBreakEnd: null,
    description: null,
  }),
  computed: {},
  watch: {
    dolarToday(value) {
      const tasa = parseFloat(value);
      // Redondear a 2 decimales
      this.dolarToday = Math.floor(tasa * 100) / 100;
    },
  },
  created() {
    localize("es");
    this.initialize();
    window.addEventListener("resize", this.initTrHeight);
  },

  mounted() {
    this.initTrHeight();
  },

  destroyed() {
    window.removeEventListener("resize", this.initTrHeight);
  },

  methods: {
    async loadCatData() {
      showLoading();
      try {
        const paramSizes = this.chargeParams("catalog");
        const paramGeographicArea = this.chargeParams("geographicArea");
        const paramOwnerships = this.chargeParams("ownerships");
        const paramCoinTyps = this.chargeParams("coinTyps");
        const paramMethodPays = this.chargeParams("methodPays");
        const paramDaliveryZones = this.chargeParams("daliveryZones");
        const paramDays = this.chargeParams("days");
        // const paramActivitys = this.chargeParams('activity')

        // resultActivitys,
        // getCatalog(paramActivitys),
        // this.listCatActivitys = _.get(resultActivitys, 'data.listOfItems.items');
        const [
          resultSizes,
          resultGeographicArea,
          resultOwnerships,
          resultCoinTyps,
          resultMethodPays,
          resultDaliveryZones,
          resultDay,
          resultCountries,
          resultDolarToday,
        ] = await Promise.all([
          getCatalog(paramSizes),
          getCatalog(paramGeographicArea),
          getCatalog(paramOwnerships),
          getCatalog(paramCoinTyps),
          getCatalog(paramMethodPays),
          getCatalog(paramDaliveryZones),
          getCatalog(paramDays),
          allCountries(),
          getDolarToday(),
        ]);
        this.listCatSizes = _.get(resultSizes, "data.listOfItems.items");
        this.listCatGeographic = _.get(
          resultGeographicArea,
          "data.listOfItems.items"
        );
        this.listCatCompany = _.get(resultOwnerships, "data.listOfItems.items");
        this.listCoinTypes = _.get(resultCoinTyps, "data.listOfItems.items");
        this.listMethodPays = _.get(resultMethodPays, "data.listOfItems.items");
        this.listDaliveryZones = _.get(
          resultDaliveryZones,
          "data.listOfItems.items"
        );
        this.allDays = _.get(resultDay, "data.listOfItems.items");

        this.listCountries = _.get(resultCountries, "data.items");
        this.dolarToday = _.get(resultDolarToday, "data");
        stopLoading();
      } catch (error) {
        stopLoading();
        this.alertToast("danger", "Error", error.message, "AlertTriangleIcon");
        console.error("Error loading data", error.message);
      }
    },
    async showCompany(guid) {
      showLoading();
      try {
        await getCompany(guid)
          .then((resp) => {
            const company = _.get(resp, "data");

            this.selected = company.productss
              ? 1
              : company.servicess
              ? 2
              : company.productsAndServices
              ? 3
              : company.informativo
              ? 4
              : company.servicesProfessional
              ? 5
              : company.reservations
              ? 6
              : false;

            Object.assign(this.companyType, {
              guid: company.companyType?.guid || null,
              idCatSize: company.companyType?.idCatSize || null,
              idCatActivity: company.companyType?.idCatActivity || null,
              idCatGeographicAreaOfOperation:
                company.companyType?.idCatGeographicAreaOfOperation || null,
              idCatCompanyOwnership:
                company.companyType?.idCatCompanyOwnership || null,
              businessContext: company.companyType?.businessContext || null,
              idCatCoinType: company.companyType?.idCatCoinType || null,
              jsonFunction: JSON.parse(company.companyType?.jsonFunction) || {},
            });

            Object.assign(this.company, {
              guidCompanyPadre: company.guid,
              companyType: this.companyType || null,
              name: company.name || null,
              //   email: company.email || null,
              idCountry: company.idCountry || null,
              idCity: company.idCity || null,
              address: company.address || null,
              phoneNumber: "",
              contactPersonName: company.contactPersonName || null,
              contactPersonEmail: company.contactPersonEmail || null,
              tasaDolar: company.tasaDolar || 0,
              contactPersonPhoneNumber: company.contactPersonPhoneNumber || "",
              workingHoursFrom:
                moment(company.workingHoursFrom, "HH:mm:ss").format("HH:mm") ||
                null,
              workingHoursTo:
                moment(company.workingHoursTo, "HH:mm:ss").format("HH:mm") ||
                null,
              urlLogo: company.urlLogo || null,
              urlPdf: company.urlPdf || null,
              urlPdfCatalogProducts: company.urlPdfCatalogProducts || null,
              connectDatabase: company.connectDatabase || false,
              frequentQuestions: company.frequentQuestions || null,
              paymentMethods: company.paymentMethods || [],
              iva: company.iva || 0,
              workSchedules: company.workSchedules || [],
              facebook: company.facebook || null,
              x: company.x || null,
              instagram: company.instagram || null,
              linkedin: company.linkedin || null,
              whatsapp: company.whatsapp || null,
              telegram: company.telegram || null,
              tiktok: company.tiktok || null,
            });

            Object.assign(this.companyFather, {
              guid: company.guid,
              companyType: this.companyType || null,
              name: company.name || null,
              email: company.email || null,
            });

            this.company.deliveryCosts = _.map(
              company.deliveryCosts,
              (model) => {
                return {
                  id: model.idCostDelivery || null,
                  idCatZona: model.idCatZona || null,
                  nameCatZona: model.nameZone || null,
                  idCity: model.idCity || null,
                  nameCity: model.nameCity || null,
                  amount: model.amount || 0,
                };
              }
            );

            this.frequentQuestions = _.map(
              this.company.frequentQuestions,
              (model) => {
                return {
                  question: model.question || null,
                  answer: model.answer || null,
                  uuid: model.idCompanyFrequentQuestion || null,
                };
              }
            );

            this.getCities(this.company.idCountry);
            stopLoading();
          })
          .catch((error) => {
            stopLoading();
            console.error("Error loading data", error.message);
            this.alertToast(
              "danger",
              "Error",
              error.message,
              "AlertTriangleIcon"
            );
          });
      } catch (error) {
        stopLoading();
        console.error("Error loading data", error.message);
        this.alertToast("danger", "Error", error.message, "AlertTriangleIcon");
      }
    },
    async countryChanged(countryId) {
      this.company.idCity = null;
      this.listCities = [];
      if (countryId) await this.getCities(countryId);
    },
    getCities(countryId) {
      try {
        showLoading();
        allCities(countryId)
          .then((result) => {
            this.listCities = _.get(result, "data.items");
          })
          .catch((error) => {
            console.error("Error loading data", error.message);
            this.alertToast(
              "danger",
              "Error",
              error.message,
              "AlertTriangleIcon"
            );
          });
      } catch (error) {
        console.error("Error loading data", error.message);
        this.alertToast("danger", "Error", error.message, "AlertTriangleIcon");
      } finally {
        stopLoading();
      }
    },
    async initialize() {
      this.option = this.$route.params.option || "";

      if (!this.option) {
        this.$router.push({ name: "companies" });
        return;
      }
      this.onCancel();
      switch (this.option) {
        case 1:
          await this.loadCatData();
          if (this.$route.params.guid === undefined) {
            this.$router.push({ name: "companies" });
            return;
          }
          this.isSaveMode = this.option !== 2;
          await Promise.all([
            this.loadCatData(),
            this.showCompany(this.$route.params.guid),
          ]);
          break;
        case 2:
        case 3:
          if (this.$route.params.guid === undefined) {
            this.$router.push({ name: "companies" });
            return;
          }
          this.isSaveMode = this.option !== 2;
          await Promise.all([
            this.loadCatData(),
            this.showCompany(this.$route.params.guid),
          ]);
          break;
      }
    },
    label(field) {
      return `pages.companies.form.label.${field}`;
    },
    labelHeader(field) {
      return `pages.companies.table.tableHeader.${field}`;
    },
    getTitle() {
      if (this.option === 1) return "register";
      else if (this.option === 2) return "show";
      else if (this.option === 3) return "edit";
    },
    onDropdownOpen(isOpen) {
      this.openTelInput = isOpen;
    },
    numberValidate() {
      // Convertir el valor a cadena de texto para aplicar replace
      let stringAmount = String(this.amount);

      // Expresión regular que permite solo números positivos con decimales
      const regex = /^[1-9]\d*(\,\d{1,2})?$/;

      // Reemplazar cualquier carácter que no sea número o punto decimal
      const sanitizedValue = stringAmount.replace(/[^0-9.]/g, "");

      // Evitar más de un punto decimal
      const decimalCount = (sanitizedValue.match(/\./g) || []).length;
      if (decimalCount > 1) {
        this.amount = 1;
        return;
      }
      // Si el valor es válido según la expresión regular, actualizamos el campo
      if (regex.test(sanitizedValue)) {
        this.amount = sanitizedValue;
      } else {
        // Si no es válido, lo reiniciamos a 1
        this.amount = 1;
      }
    },
    chargeParams(key) {
      let arrParams = [];
      arrParams.push(`itemsPage,${this.itemsPage}`);
      arrParams.push(`itemsRows,${this.itemsRows}`);

      switch (key) {
        case "catalog":
          arrParams.push("guidCatalog, 6e66d474-5417-436a-8f56-3186d97f6173");
          break;
        case "geographicArea":
          arrParams.push("guidCatalog, 0cdd192f-9e6c-4c1b-bff9-ded669f36bca");
          break;
        case "ownerships":
          arrParams.push("guidCatalog, 95da642c-78ad-4365-9410-ca2996bd3f3f");
          break;
        case "coinTyps":
          arrParams.push("guidCatalog, 20ce3c04-4594-4398-adae-f8def7bd8f25");
          break;
        case "methodPays":
          arrParams.push("guidCatalog, 97ba7fc1-0312-4a6f-a5eb-12a4cfe6c592");
          break;
        case "daliveryZones":
          arrParams.push("guidCatalog, cc37980c-60e5-4f7d-a91a-8ef4d6078057");
          break;
        case "days":
          arrParams.push("guidCatalog, 2e42df02-8ea5-4e59-8180-51cd039e055a");
          break;
      }
      return getParams(arrParams);
    },
    repeateAgain() {
      this.frequentQuestions.push({
        uuid: (this.nextTodoId += this.nextTodoId),
      });
      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight);
      });
    },
    removeItem(index) {
      this.frequentQuestions.splice(index, 1);
      this.trTrimHeight(this.$refs.row[0].offsetHeight);
    },
    initTrHeight() {
      this.trSetHeight(null);
      this.$nextTick(() => {
        if (!!this.$refs.formDetailCompany) {
          this.trSetHeight(this.$refs.formDetailCompany.scrollHeight);
        }
      });
    },
    onSubmit() {
      showLoading();
      try {
        this.validationDetailCompany()
          .then((validate) => {
            if (validate) {
              switch (this.selected) {
                case 1:
                  this.company.productss = true;
                  this.company.servicess =
                    this.company.productsAndServices =
                    this.company.informativo =
                    this.company.servicesProfessional =
                    this.company.reservations =
                      false;
                  break;
                case 2:
                  this.company.servicess = true;
                  this.company.productss =
                    this.company.productsAndServices =
                    this.company.informativo =
                    this.company.servicesProfessional =
                    this.company.reservations =
                      false;
                  break;
                case 3:
                  this.company.productsAndServices = true;
                  this.company.productss =
                    this.company.servicess =
                    this.company.informativo =
                    this.company.servicesProfessional =
                    this.company.reservations =
                      false;
                  break;
                case 4:
                  this.company.informativo = true;
                  this.company.productss =
                    this.company.productsAndServices =
                    this.company.servicess =
                    this.company.servicesProfessional =
                    this.company.reservations =
                      false;
                  break;
                case 5:
                  this.company.servicesProfessional = true;
                  this.company.productss =
                    this.company.productsAndServices =
                    this.company.informativo =
                    this.company.servicess =
                    this.company.reservations =
                      false;
                  break;
                case 6:
                  this.company.reservations = true;
                  this.company.productss =
                    this.company.productsAndServices =
                    this.company.servicess =
                    this.company.informativo =
                    this.company.servicesProfessional =
                      false;
                  break;
              }

              this.company.companyType = this.companyType;
              this.company.frequentQuestions = this.frequentQuestions;
              this.company.workingHoursFrom = moment(
                this.company.workingHoursFrom,
                "HH:mm"
              ).format("HH:mm:ss");
              this.company.workingHoursTo = moment(
                this.company.workingHoursTo,
                "HH:mm"
              ).format("HH:mm:ss");

              // if (this.company.paymentMethods.length > 0) {
              //   let lastElementIndex = this.company.paymentMethods.length - 1;
              //   delete this.company.paymentMethods[lastElementIndex].nameType;
              //   delete this.company.paymentMethods[lastElementIndex].uuid;
              // }

              this.company.companyType.jsonFunction = JSON.stringify(
                this.company.companyType.jsonFunction
              );
              const guid = this.option === 1 ? null : this.company.guid;

              createOrEditSucursal(this.company, guid)
                .then((response) => {
                  console.log("resp", response);
                  this.alertToast(
                    "success",
                    this.$t("Alert"),
                    `${
                      this.option != 3
                        ? this.$t("registerSuccess")
                        : this.$t("updateRecord")
                    }`,
                    "CheckIcon"
                  );
                  this.goBack();
                  stopLoading();
                })
                .catch((error) => {
                  stopLoading();
                  console.error("Error loading data", error.message);
                  this.alertToast(
                    "danger",
                    "Error",
                    error.message,
                    "AlertTriangleIcon"
                  );
                });
            }
          })
          .catch((error) => {
            console.error("Error loading data", error.message);
            this.alertToast(
              "danger",
              "Error",
              error.message,
              "AlertTriangleIcon"
            );
          });
      } catch (error) {
        console.error("Error loading data", error.message);
        this.alertToast("danger", "Error", error.message, "AlertTriangleIcon");
      }
    },
    validationTypeCompany() {
      return new Promise((resolve, reject) => {
        this.$refs.typeCompanyRules.validate().then((success) => {
          if (success) {
            resolve(true);
          } else {
            reject();
          }
        });
      });
    },
    validationDetailCompany() {
      return new Promise((resolve, reject) => {
        this.$refs.detailCompanyRules.validate().then((success) => {
          if (success) {
            resolve(true);
          } else {
            reject();
          }
        });
      });
    },
    validationPayCompany() {
      return new Promise((resolve, reject) => {
        this.$refs.payCompanyRules.validate().then((success) => {
          if (success) {
            resolve(true);
          } else {
            reject();
          }
        });
      });
    },
    validationDeliveryCompany() {
      return new Promise((resolve, reject) => {
        this.$refs.deliveryCompanyRules.validate().then((success) => {
          if (success) {
            resolve(true);
          } else {
            reject();
          }
        });
      });
    },
    validationWorkSchedules() {
      return new Promise((resolve, reject) => {
        this.$refs.workSchedulesRules.validate().then((success) => {
          if (success) {
            resolve(true);
          } else {
            reject();
          }
        });
      });
    },
    notDecimal() {
      const regex = /^\d{1,2}$/; // Expresión regular para uno o dos dígitos
      const inputValue = parseInt(this.company.iva, 10); // Convertir a número entero

      // Validar que el valor esté entre 1 y 100, y sea un número válido (no NaN)
      if (
        !regex.test(this.company.iva.toString()) ||
        inputValue < 1 ||
        inputValue > 100
      ) {
        // Si el valor no es válido, lo establece a 0 o a cualquier valor predeterminado
        this.company.iva = 0;
      }
    },
    onJsonChange() {},
    handleDragover(e) {
      e.stopPropagation();
      e.preventDefault();
      e.dataTransfer.dropEffect = "copy";
    },
    handleDrop(e, field) {
      e.stopPropagation();
      e.preventDefault();
      const { files } = e.dataTransfer;
      if (files.length !== 1) {
        return;
      }
      const accept =
        e.target.getAttribute("accept") ||
        e.target.parentElement.getAttribute("accept");
      const multiple =
        e.target.getAttribute("multiple") ||
        e.target.parentElement.getAttribute("multiple");
      this.onTransFile(files, accept, multiple, field);
    },
    onFileChange(e, field) {
      if (e?.target?.files?.length > 0) {
        this.onTransFile(
          e?.target?.files,
          e.target.accept,
          e.target.multiple,
          field
        );
      }
    },
    onTransFile(files, accept, multiple, field) {
      if (multiple) return;
      files.forEach((file) => {
        if (!file) return;
        const type = file.type.split("/").pop();
        const isPdf = type === "pdf";
        const isImage = ["jpeg", "jpg", "png"].includes(type);
        if (!isPdf && !isImage) return;
        showLoading();
        postFile(file)
          .then((resp) => {
            this.company[field] = resp.data;
          })
          .catch((error) => {
            console.error("Error loading data", error.message);
            this.alertToast(
              "danger",
              "Error",
              error.message,
              "AlertTriangleIcon"
            );
          });
      });
    },
    deleteFile(field) {
      this.company[field] = null;
    },
    addPay() {
      if (!this.payMethod) {
        this.alertToast(
          "danger",
          this.$t("Alert"),
          this.$t("pages.companies.payRequired"),
          "AlertTriangleIcon"
        );
        return;
      }
      const random = () => ((1 + Math.random()) * 0x100000) | 0;
      const block = () =>
        (+moment.now() + random() + random() + random()).toString(16);
      const id = `${block()}-${block()}-${block()}`;
      this.company.paymentMethods.push({
        uuid: id,
        idCatType: this.payMethod.id,
        nameType: this.payMethod.name,
        information: this.information,
      });
      this.payMethod = null;
      this.information = null;
    },
    addSchedules() {
      if (
        !this.catDay ||
        [this.startTime, this.endTime].some((item) => item == null)
      ) {
        this.alertToast(
          "danger",
          this.$t("Alert"),
          this.$t("pages.companies.schedulesRequired"),
          "AlertTriangleIcon"
        );
        return;
      }
      // Verificar si idCatDay ya existe en workSchedules
      const exists = this.company.workSchedules.some(
        (schedule) => schedule.idCatDay === this.catDay.id
      );
      if (exists) {
        this.alertToast(
          "danger",
          this.$t("Alert"),
          this.$t("pages.companies.scheduleAlreadyExists"),
          "AlertTriangleIcon"
        );
        return;
      }
      const random = () => ((1 + Math.random()) * 0x100000) | 0;
      const block = () =>
        (+moment.now() + random() + random() + random()).toString(16);
      const id = `${block()}-${block()}-${block()}`;
      // Agregar nuevo horario
      this.company.workSchedules.push({
        uuid: id,
        idCatDay: this.catDay?.id,
        nameDay: this.catDay?.name,
        startTime: this.startTime,
        endTime: this.endTime,
        timeBreakStart:
          this.timeBreakStart === null || this.timeBreakStart === ""
            ? null
            : this.timeBreakStart,
        timeBreakEnd:
          this.timeBreakEnd === null || this.timeBreakEnd === ""
            ? null
            : this.timeBreakEnd,
        description: this.description ?? null,
      });

      // Limpiar campos
      this.catDay = null;
      this.startTime = null;
      this.endTime = null;
      this.timeBreakStart = null;
      this.timeBreakEnd = null;
      this.description = null;
    },
    formattedTime(time24) {
      let [hour, minute, second] = time24.split(":");
      hour = parseInt(hour);
      const ampm = hour >= 12 ? "PM" : "AM";

      hour = hour % 12 || 12;
      return `${hour}:${minute} ${ampm}`;
    },
    onDeletePay(item) {
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("willNotBeAble"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("yesDelete"),
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          if (item.uuid) {
            const index = this.company.paymentMethods.findIndex(
              (model) => model.uuid === item.uuid
            );
            this.company.paymentMethods.splice(index, 1);
            this.alertToast(
              "success",
              this.$t("Alert"),
              this.$t("delete_success"),
              "CheckIcon"
            );
          } else {
            this.removePaymentMethod(
              item.guidCompany,
              item.idCompanyPaymentMethods
            );
          }
        } else if (result.dismiss === "cancel") {
        }
      });
    },
    onDeleteSchedules(item) {
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("willNotBeAble"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("yesDelete"),
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          if (item.uuid) {
            const index = this.company.workSchedules.findIndex(
              (model) => model.uuid === item.uuid
            );
            this.company.workSchedules.splice(index, 1);
            this.alertToast(
              "success",
              this.$t("Alert"),
              this.$t("delete_success"),
              "CheckIcon"
            );
          } else {
            this.removeHoursMethod(
              item.guidCompany,
              item.idCompanyWorkingHours
            );
          }
        } else if (result.dismiss === "cancel") {
          this.message(
            this.$t("canceled"),
            this.$t("registerDeletedCanceled"),
            "error"
          );
        }
      });
    },
    removePaymentMethod(guidCompany, idCompanyPaymentMethods) {
      // try {
      //   showLoading();
      //   deletePaymentMethods(guidCompany, idCompanyPaymentMethods)
      //     .then((result) => {
      //       const index = this.company.paymentMethods.findIndex(
      //         (model) => model.idCompanyPaymentMethods === idCompanyPaymentMethods
      //       );
      //       this.company.paymentMethods.splice(index, 1);
      //       this.alertToast("success", this.$t("Alert"), this.$t("delete_success"), "CheckIcon");
      //     })
      //     .catch((error) => {
      //       console.error("Error loading data", error.message);
      //       this.alertToast("danger", "Error", error.message, "AlertTriangleIcon");
      //     });
      // } catch (error) {
      //   console.error("Error loading data", error.message);
      //   this.alertToast("danger", "Error", error.message, "AlertTriangleIcon");
      // } finally {
      //   stopLoading();
      // }
    },
    removeHoursMethod(guidCompany, idCompanyWorkingHours) {
      try {
        showLoading();
        deleteHoursMethods(guidCompany, idCompanyWorkingHours)
          .then((result) => {
            const index = this.company.workSchedules.findIndex(
              (model) => model.idCompanyWorkingHours === idCompanyWorkingHours
            );
            this.company.workSchedules.splice(index, 1);
            this.alertToast(
              "success",
              this.$t("Alert"),
              this.$t("delete_success"),
              "CheckIcon"
            );
          })
          .catch((error) => {
            console.error("Error loading data", error.message);
            this.alertToast(
              "danger",
              "Error",
              error.message,
              "AlertTriangleIcon"
            );
          });
      } catch (error) {
        console.error("Error loading data", error.message);
        this.alertToast("danger", "Error", error.message, "AlertTriangleIcon");
      } finally {
        stopLoading();
      }
    },
    addDelivery() {
      if (
        !this.zonaCatalog ||
        !this.amount ||
        this.amount <= 0 ||
        !this.company.idCity
      ) {
        this.alertToast(
          "danger",
          this.$t("Alert"),
          this.$t("pages.companies.deliveryRequired"),
          "AlertTriangleIcon"
        );
        return;
      }
      const city = this.listCities.find(
        (city) => city.idCity === this.company.idCity
      );

      if (!city) {
        this.alertToast(
          "danger",
          this.$t("Alert"),
          this.$t("pages.companies.cityRequired"),
          "AlertTriangleIcon"
        );
        return;
      }
      const random = () => ((1 + Math.random()) * 0x100000) | 0;
      const block = () =>
        (+moment.now() + random() + random() + random()).toString(16);
      const id = `${block()}-${block()}-${block()}`;
      this.company.deliveryCosts.push({
        uuid: id,
        idCatZona: this.zonaCatalog.id,
        nameCatZona: this.zonaCatalog.name,
        idCity: this.company.idCity,
        nameCity: city.name,
        amount: this.amount,
      });

      this.zonaCatalog = null;
      this.amount = null;
    },
    onDeleteDelivery(item) {
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("willNotBeAble"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("yesDelete"),
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          if (item.uuid) {
            const index = this.company.deliveryCosts.findIndex(
              (model) => model.uuid === item.uuid
            );
            this.company.deliveryCosts.splice(index, 1);
          } else {
            this.removeDeliveryMethod(item.guidCompany, item.id);
          }
        } else if (result.dismiss === "cancel") {
          this.message(
            this.$t("canceled"),
            this.$t("registerDeletedCanceled"),
            "error"
          );
        }
      });
    },
    removeDeliveryMethod(guidCompany, idCompanyPaymentMethods) {
      deletePaymentMethods(guidCompany, idCompanyPaymentMethods)
        .then((result) => {
          const index = this.company.deliveryCosts.findIndex(
            (model) => model.idCompanyPaymentMethods === idCompanyPaymentMethods
          );
          this.company.deliveryCosts.splice(index, 1);
        })
        .catch((error) => {
          console.error("Error loading data", error.message);
          this.alertToast(
            "danger",
            "Error",
            error.message,
            "AlertTriangleIcon"
          );
        });
    },
    goBack() {
      this.$refs.typeCompanyRules.reset();
      this.$refs.detailCompanyRules.reset();
      router.back();
      this.onCancel();
    },
    message(title, text, icon, html) {
      this.$swal({
        title,
        text,
        html,
        icon,
        customClass: {
          confirmButton: "btn btn-success",
        },
      });
    },
    onCancel() {
      this.frequentQuestions = [];
      this.companyType = Object.assign({
        guid: null,
        idCatSize: null,
        idCatActivity: null,
        idCatGeographicAreaOfOperation: null,
        idCatCompanyOwnership: null,
        businessContext: null,
        idCatCoinType: null,
        jsonFunction: {},
      });
      this.company = Object.assign({
        guid: null,
        companyType: null,
        name: null,
        email: null,
        idCountry: null,
        idCity: null,
        address: null,
        phoneNumber: "",
        contactPersonName: null,
        contactPersonEmail: null,
        contactPersonPhoneNumber: "",
        workingHoursFrom: null,
        workingHoursTo: null,
        urlLogo: null,
        urlPdf: null,
        urlPdfCatalogProducts: null,
        connectDatabase: false,
        frequentQuestions: [],
        paymentMethods: [],
        deliveryCosts: [],
        workSchedules: [],
        tasaDolar: 0,
        iva: 0,
        dolarBCV: true,
        productsAndServices: false,
        productss: false,
        servicess: false,
        informativo: false,
        professionalServices: false,
        reservations: false,
        facebook: null,
        x: null,
        instagram: null,
        linkedin: null,
        whatsapp: null,
        telegram: null,
        tiktok: null,
      });
    },
    alertToast(type = null, title = null, message = null, icon) {
      this.$bvToast.toast(message, {
        title,
        variant: type,
        solid: true,
        icon,
      });
    },
  },
};
</script>
<style lang="scss">
@import "~@core/scss/vue/libs/vue-wizard.scss";
@import "~@core/scss/vue/libs/vue-select.scss";
@import "../../../../public/loader.css";
@import "@core/scss/vue/libs/vue-select.scss";
</style>
